module.exports = __webpack_public_path__ + "static/media/bar_chart.dcd24363.svg";